import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  loading: false,
  message: null,
  error: null,
  data: [],
};

const getHomeOccupationSlice = createSlice({
  name: "getHomeOccupation",
  initialState,
  reducers: {
    getHomeOccupationStart(state, payload) {
      state.loading = true;
      state.error = null;
      state.message = null;
    },

    getHomeOccupationSuccess(state, action) {
      state.loading = false;
      const flattenedArray = []?.concat(...action?.payload);
      state.data = flattenedArray;
      state.message = action.payload.message;
    },
    getHomeOccupationFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
      state.message = null;
    },
    clearError: (state) => {
      state.error = null;
    },
    clearMessage: (state) => {
      state.message = null;
    },
  },
});

export const {
  getHomeOccupationStart,
  getHomeOccupationSuccess,
  getHomeOccupationFailure,
  clearError,
  clearMessage,
} = getHomeOccupationSlice.actions;

export default getHomeOccupationSlice.reducer;
